// Trade theme header mobile drawer
//
// Responsibility
// - Owns the slide-out mobile navigation for the custom header.
// - Manages focus trap and Escape handling for accessibility.
// - Applies and removes a body-level scroll lock class while the drawer is open.
//
// Boundaries
// - Markup comes from sections/header-custom.liquid.
// - Layout and visuals are handled in assets/component-header.css.
// - This script intentionally avoids business logic (cart, wishlist, etc.).

(function (){
  'use strict';

  var BODY_CLASS_OPEN = 'mobile-nav-open';

  function qsAll(selector){ return Array.prototype.slice.call(document.querySelectorAll(selector)); }
  function qs(selector){ return document.querySelector(selector); }

  function getFocusable(container){
    if (!container) return [];
    return qsAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(function(el){
      return container.contains(el) && el.offsetParent !== null;
    });
  }

  // Focus trap: keep keyboard focus inside the open drawer while it is visible.
  function installTrap(entry){
    if (!entry) return;
    var list = getFocusable(entry.node);
    var first = list[0];
    var last = list[list.length - 1];
    entry._trap = function(e){
      if (e.key !== 'Tab') return;
      if (!first || !last){ e.preventDefault(); return; }
      if (e.shiftKey){ if (document.activeElement === first){ e.preventDefault(); last.focus(); } }
      else { if (document.activeElement === last){ e.preventDefault(); first.focus(); } }
    };
    document.addEventListener('keydown', entry._trap);
  }

  function removeTrap(entry){ if (!entry || !entry._trap) return; document.removeEventListener('keydown', entry._trap); entry._trap = null; }

  // Open a specific drawer instance and apply body scroll lock.
  function openDrawer(id, trigger){
    var entry = window.TradeHeaderDrawer && window.TradeHeaderDrawer._drawers && window.TradeHeaderDrawer._drawers[id];
    if (!entry) return;
    try{ entry.prev = document.activeElement; }catch(e){ entry.prev = null; }
    Object.keys(window.TradeHeaderDrawer._drawers).forEach(function(k){ if (k !== id) closeDrawer(k); });
    entry.node.setAttribute('aria-hidden','false');
    entry.node.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded','true');
    document.body.classList.add(BODY_CLASS_OPEN);
    document.body.style.overflow = 'hidden'; // Scroll lock (see assets/component-header.css for .mobile-nav-open)
    var focusTarget = entry.close || getFocusable(entry.node)[0] || entry.node;
    try{ focusTarget.focus(); }catch(e){}
    entry._esc = function(e){ if (e.key === 'Escape') closeDrawer(id, trigger); };
    document.addEventListener('keydown', entry._esc);
    installTrap(entry);
  }

  // Close a specific drawer instance and restore scroll.
  function closeDrawer(id, trigger){
    var entry = window.TradeHeaderDrawer && window.TradeHeaderDrawer._drawers && window.TradeHeaderDrawer._drawers[id];
    if (!entry) return;
    entry.node.setAttribute('aria-hidden','true');
    entry.node.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded','false'); else { var t = document.querySelector('[aria-controls="' + id + '"]'); if (t) t.setAttribute('aria-expanded','false'); }
    document.body.classList.remove(BODY_CLASS_OPEN);
    document.body.style.overflow = '';
    if (entry._esc) document.removeEventListener('keydown', entry._esc);
    entry._esc = null;
    removeTrap(entry);
    try{ if (entry.prev && typeof entry.prev.focus === 'function') entry.prev.focus(); }catch(e){}
  }

  function init(){
    var toggles = qsAll('[data-mobile-menu-toggle]');
    var drawers = qsAll('[id^="MobileNavDrawer-"]');
    var overlays = qsAll('[data-mobile-menu-overlay]');
    var closes = qsAll('[data-mobile-menu-close]');
    if (!toggles.length || !drawers.length) return;

    var map = {};
    drawers.forEach(function(d){ map[d.id] = { node: d, close: d.querySelector('[data-mobile-menu-close]') || null, overlay: d.querySelector('[data-mobile-menu-overlay]') || null, prev: null, _trap: null, _esc: null }; });

    toggles.forEach(function(btn){
      var target = btn.getAttribute('aria-controls');
      if (!target) return;
      if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded','false');
      btn.addEventListener('click', function(){
        var drawer = document.getElementById(target);
        if (!drawer) return;
        var hidden = drawer.getAttribute('aria-hidden') === 'true';
        if (hidden) openDrawer(target, btn); else closeDrawer(target, btn);
      });
    });

    closes.forEach(function(btn){
      var target = btn.getAttribute('aria-controls') || (btn.closest('[id^="MobileNavDrawer-"]') || {}).id;
      btn.addEventListener('click', function(){ if (target) closeDrawer(target, btn); });
    });

    overlays.forEach(function(ov){ var parent = ov.closest('[id^="MobileNavDrawer-"]'); ov.addEventListener('click', function(){ if (parent) closeDrawer(parent.id); }); });

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ Object.keys(map).forEach(function(k){ var ent = map[k]; if (ent && ent.node && ent.node.classList.contains('is-open')) closeDrawer(k); }); } });

    // Expose a minimal global helper so other scripts (or theme editor preview)
    // can open/close the drawer without duplicating logic.
    window.TradeHeaderDrawer = window.TradeHeaderDrawer || {};
    window.TradeHeaderDrawer.open = openDrawer;
    window.TradeHeaderDrawer.close = closeDrawer;
    window.TradeHeaderDrawer._drawers = map;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();
